import { render, staticRenderFns } from "./customizePagePopup.vue?vue&type=template&id=04a476ca&scoped=true"
import script from "./customizePagePopup.vue?vue&type=script&lang=js"
export * from "./customizePagePopup.vue?vue&type=script&lang=js"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&lang=css&external"
import style1 from "./customizePagePopup.vue?vue&type=style&index=1&id=04a476ca&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a476ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04a476ca')) {
      api.createRecord('04a476ca', component.options)
    } else {
      api.reload('04a476ca', component.options)
    }
    module.hot.accept("./customizePagePopup.vue?vue&type=template&id=04a476ca&scoped=true", function () {
      api.rerender('04a476ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/operationManagement/customizePageManagement/components/customizePagePopup.vue"
export default component.exports